// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "c00dd5d-dirty",
    "hash": "c00dd5d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c00dd5d-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
